<template>
  <PageContentLayoutOnly role="region" financial-info>
    <section class="section">
      <div class="pl-5 pr-5">
        <div class="level pl-5 pr-5">
          <div class="pt-5 level-left level-item title">{{ $t('financialInfo.title') }}</div>
          <div class="level-right">
            <div class="level-item">
              <svg
                width="30"
                height="30"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </div>
            <div class="level-item">
              <b-button label="Back to Onboarding" @click.prevent="returnToParent()" />
            </div>
          </div>
        </div>
        <div class="box is-12">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(onFormSubmit)" class="form">
                <fieldset>
                  <div>
                    <div class="column is-12">
                      <valid-input
                        style="width:50px !important;"
                        name="FederalTaxId"
                        label="EIN Federal Tax ID"
                        maxlength="20"
                        type="text"
                        vid="FederalTaxId"
                        placeholder="EIN Federal Tax ID"
                        spellcheck="true"
                        aria-label="EIN Federal Tax ID"
                        rules="max:20|required"
                        class="is-small"
                        v-model="formData.federalTaxId"
                      />
                    </div>
                    <div class="column is-12">
                      <valid-input
                        style="width:50px !important;"
                        name="Assessments"
                        label="Assessments"
                        maxlength="8000"
                        type="textarea"
                        vid="Assessments"
                        placeholder="Assessments"
                        spellcheck="true"
                        aria-label="Assessments"
                        rules="max:8000|required"
                        class="is-small"
                        v-model="formData.assessments"
                      />
                    </div>
                    <div class="column is-12">
                      <valid-input
                        style="width:50px !important;"
                        name="LateFees"
                        label="Late Fees"
                        maxlength="8000"
                        type="textarea"
                        vid="LateFees"
                        placeholder="Late Fees"
                        spellcheck="true"
                        aria-label="Late Fees"
                        rules="max:8000|required"
                        class="is-small"
                        v-model="formData.lateFees"
                      />
                    </div>
                    <div class="column is-12">
                      <valid-input
                        style="width:50px !important;"
                        name="ClosingFees"
                        label="Closing Fees"
                        maxlength="8000"
                        type="textarea"
                        vid="ClosingFees"
                        placeholder="Closing Fees"
                        spellcheck="true"
                        aria-label="Closing Fees"
                        rules="max:8000|required"
                        class="is-small"
                        v-model="formData.closingFees"
                      />
                    </div>
                    <div class="column is-12">
                      <valid-input
                        style="width:50px !important;"
                        name="ParcelTaxNumbers"
                        label="Parcel Tax Numbers"
                        maxlength="8000"
                        type="textarea"
                        vid="ParcelTaxNumbers"
                        placeholder="Parcel Tax Numbers"
                        spellcheck="true"
                        aria-label="Parcel Tax Numbers"
                        rules="max:8000|required"
                        class="is-small"
                        v-model="formData.parcelTaxNumbers"
                      />
                    </div>
                    <div class="column is-12">
                      <button type="submit" class="button is-primary is-rounded">
                        Submit
                      </button>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
    </section>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ValidInput from '@/components/inputs/ValidInput'
import { data } from './keys/data'
import { methods } from './keys/methods'

export default {
  components: {
    ValidInput,
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    }),
    ...mapGetters('user', ['authUser'])
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  mounted() {
    this.reload()
  },

  methods,

  i18n: {
    messages: {
      en: { financialInfo: { title: 'Financial Information' } }
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-avatar {
  margin: 1em auto 2em;
}

.card {
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05) !important;

  .card {
    border: 0 !important;
  }
}

.avatar-img {
  border: 1px solid #e7e8f2;
  padding: 0.25em;
}

.address-card {
  h5,
  h6 {
    margin: 0;
  }
}

.details-img {
  img {
    border-radius: 0.5em;
  }
}
</style>
